module.exports = __webpack_public_path__ + "media/images/countryrect/eg-24b6c719518015a6f242228eb2756468.svg";